export default {
  getAll (state) {
    return state.all
  },
  getCategories (state) {
    return state.categories
  }
}
